import React, { useContext } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import BottomNav from './BottomNav';
import { AuthContext } from '../../context/AuthContext';
import SafeIcon from '../../common/SafeIcon';

const MobileLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext);
  const hideNavRoutes = ['/create', '/invite'];
  
  const shouldHideNav = hideNavRoutes.some(route => location.pathname.startsWith(route));
  const isProfile = location.pathname === '/profile';

  return (
    <div className="mobile-container">
      {/* Profile Top Bar with Logout */}
      {isProfile && user && (
        <div className="bg-white px-4 py-3 flex items-center justify-between border-b border-gray-100">
          <h1 className="font-bold text-gray-800">Profile</h1>
          <button
            onClick={() => {
              logout();
              navigate('/');
            }}
            className="text-sm text-red-500 font-medium flex items-center gap-1 px-3 py-1.5 rounded-lg hover:bg-red-50 transition-colors"
          >
            <SafeIcon name="LogOut" className="text-sm" />
            Logout
          </button>
        </div>
      )}

      <div className={`flex-1 overflow-y-auto ${shouldHideNav ? '' : 'pb-20'}`}>
        <Outlet />
      </div>
      {!shouldHideNav && <BottomNav />}
    </div>
  );
};

export default MobileLayout;